import { Box, Typography } from "@mui/material";

const LimitedTextBox = ({ title, content, limit }) => {
  return (
    <Box
      sx={{
        display: "-webkit-box",
        textOverflow: "ellipsis",
        WebkitLineClamp: limit,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        alignItems: "start",
        lineHeight: 1,
      }}
    >
      {title && (
        <Typography variant="subtitle2" display="inline">
          {title}:{" "}
        </Typography>
      )}
      <Typography variant="caption" display="inline">
        {content}
      </Typography>
    </Box>
  );
};

export default LimitedTextBox;
